import { render, staticRenderFns } from "./ModalPreviewOffering.vue?vue&type=template&id=bbb014b4&scoped=true"
import script from "./ModalPreviewOffering.vue?vue&type=script&lang=js"
export * from "./ModalPreviewOffering.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewOffering.vue?vue&type=style&index=0&id=bbb014b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb014b4",
  null
  
)

export default component.exports